// @flow
import { METHODS } from "../../../scenes/BookingRefund/consts/refundConsts"
import type { RefundMethods } from "mmb/records/bookingInput"

const methods = Object.values(METHODS)

// default value [] is needed to not break tests
const mapperBookingRefund = (refundMethods: RefundMethods = []): string[] =>
  // $FlowFixMe
  refundMethods.sort((a: string, b: string) => methods.indexOf(a) - methods.indexOf(b))

export default mapperBookingRefund
